const $ = window.jQuery;

let $frontPageForewordMain = $('.front-page-foreword-main');
let $frontPageForewordContentPhraseText = $('.front-page-foreword-content-phrase-text');
let $frontPageForewordGalleryImage = $('.front-page-foreword-gallery img');

$frontPageForewordContentPhraseText
  .mouseenter(function () {
    let index = $frontPageForewordContentPhraseText.index($(this));
    $frontPageForewordMain.addClass('mouseenter').removeClass('mouseleave');
    $frontPageForewordGalleryImage.removeClass('former-active active-initial');
    $('.front-page-foreword-gallery img.active').removeClass('active').addClass('former-active');
    $frontPageForewordGalleryImage.eq(index).addClass('active');
  })
  .mouseleave(function () {
    $frontPageForewordMain.removeClass('mouseenter').addClass('mouseleave');
  });
